import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MenuArbolComponent } from "./components/menu-arbol/menu-arbol.component";
import { NodoArbolComponent } from "./components/menu-arbol/nodo-arbol/nodo-arbol.component";
import { AsistenciaMenuArbolComponent } from "./asistencia-menu-arbol.component";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule, MatButtonModule],
  exports: [AsistenciaMenuArbolComponent],
  declarations: [
    AsistenciaMenuArbolComponent,
    MenuArbolComponent,
    NodoArbolComponent,
  ],
})
export class AsistenciaMenuArbolModule {}
